import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { LotItemProxyService } from '../../../proxies/inventory/lot-item.proxy.service';
import { LotItem } from '../../../models/inventory/lot-item';
import { InventorySearchCommand } from '../../../models/inventory-summary';
import { AuthService } from '@card-software/nexus-utilities';
import { UserGroup } from '../../../models/authorization/enum/user-group.enum';

@Component({
  selector: 'app-split-lot-items-list',
  templateUrl: './split-lot-items-list.component.html',
  styleUrl: './split-lot-items-list.component.scss',
})
export class SplitLotItemsListComponent implements OnInit {
  isLoading = 0;
  showFilters = signal<boolean>(true);
  dataSource: LotItem[] = [];
  filtersForm: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private lotItemProxyService: LotItemProxyService,
  ) {
    this.filtersForm = this.createFiltersForm();
  }

  canEdit() {
    // if Admin or Editor
    if (AuthService.hasRole(UserGroup.SplitLotItemAdmin)) {
      return true;
    }
    // if Viewer
    if (AuthService.hasRole(UserGroup.SplitLotItemViewer)) {
      return false;
    }
    // Default
    return false;
  }

  createFiltersForm(): FormGroup {
    return this.formBuilder.group({
      lotId: [''],
      lotItemSplited: [''],
    });
  }

  ngOnInit(): void {
    this.loadTableData();
  }

  loadTableData() {
    const filters = this.filtersForm.value;

    if (!filters.lotId && !filters.lotItemSplited) {
      this.dataSource = [];
      return;
    }

    this.isLoading++;
    const command: InventorySearchCommand = {
      lotItemNumbers: filters.lotId ? [filters.lotId] : undefined,
      manufacturerLotNumbers: filters.lotItemSplited ? [filters.lotItemSplited] : undefined,
    };

    this.lotItemProxyService
      .batchSearch(command)
      .pipe(
        finalize(() => {
          this.isLoading--;
        }),
      )
      .subscribe({
        next: (res) => {
          if (res.data) {
            this.dataSource = res.data;
          }
        },
        error: (err) => {
          console.error('Error fetching lot items:', err);
        },
      });
  }

  redirectToDetail(id?: string): void {
    const queryParams = id ? { id: id } : {};
    this.router.navigate(['/split-lot-items-details'], { queryParams });
  }

  resetFilters(): void {
    this.filtersForm.reset();
    this.loadTableData();
  }
}
